import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import s from "./404.less";

interface Props {}

const PageNotFound: FC<Props> = ({}) => {
  const { t } = useTranslation();
  return <div className={s.page_not_found}>{t("common.page_not_found")}</div>;
};

export default PageNotFound;
